var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormsSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C4.5 9.44771 4.94772 9 5.5 9H18.5C19.0523 9 19.5 9.44772 19.5 10V18.5C19.5 19.0523 19.0523 19.5 18.5 19.5H5.5C4.94772 19.5 4.5 19.0523 4.5 18.5V10Z",
    fill: "#00E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25C4.5 5.66421 4.83579 6 5.25 6H11.75C12.1642 6 12.5 5.66421 12.5 5.25C12.5 4.83579 12.1642 4.5 11.75 4.5H5.25Z",
    fill: "#00E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.23122 1.23122 0 2.75 0H21.25C22.7688 0 24 1.23122 24 2.75V21.25C24 22.7688 22.7688 24 21.25 24H2.75C1.23122 24 0 22.7688 0 21.25V2.75ZM2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V21.25C1.5 21.9404 2.05964 22.5 2.75 22.5H21.25C21.9404 22.5 22.5 21.9404 22.5 21.25V2.75C22.5 2.05964 21.9404 1.5 21.25 1.5H2.75Z",
    fill: "#00E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsSelectedIcon);
export default __webpack_public_path__ + "static/media/formsSelectedIcon.e502bd3f3d9599a29af15e6d87f9abb5.svg";
export { ForwardRef as ReactComponent };